/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import styles from './styles.module.css';
import statusStyles from '../../styles.module.css';
import { useTranslation } from 'react-i18next';

export const BatteryStatus = props => {
  const { value } = props;
  let style;
  const { t } = useTranslation();
  if (value > 90) {
    style = statusStyles.success;
  } else if (value > 50) {
    style = statusStyles.warning;
  } else {
    style = statusStyles.danger;
  }

  return (
    <div className={`${styles.container} ${style}`}>
      <div>{t('label_battery')}</div>
      <div className={styles.value}>
        {value}
        <small className={styles.percentageMark}> %</small>
      </div>
    </div>
  );
};

export default BatteryStatus;
